const constant = {};
constant.APP_SET_ALERT_MESSAGE = "APP_SET_ALERT_MESSAGE";
constant.APP_CLOSE_ALERT_MESSAGE = "APP_CLOSE_ALERT_MESSAGE";
constant.SET_LOADING_STATUS = "SET_LOADING_STATUS";

constant.SET_ADMIN_LOGGED_IN = "SET_ADMIN_LOGGED_IN";

constant.FETCH_PRODUCTS_DATA_SUCCESS = "FETCH_PRODUCTS_DATA_SUCCESS";
constant.FETCH_SINGLE_PRODUCT_DATA_SUCCESS =
  "FETCH_SINGLE_PRODUCT_DATA_SUCCESS";
constant.ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
constant.DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
constant.UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";

constant.USER_CHANGE_PRODUCT_QUANTITY = "USER_CHANGE_PRODUCT_QUANTITY";
constant.USER_ORDER_CONFIRM_SUCCESS = "USER_ORDER_CONFIRM_SUCCESS";
constant.FETCH_USER_ORDERS_SUCCESS = "FETCH_USER_ORDERS_SUCCESS";
constant.ORDER_DELETE_SUCCESS = "ORDER_DELETE_SUCCESS";
constant.FETCH_ALL_ORDERS_SUCCESS = "FETCH_ALL_ORDERS_SUCCESS";
constant.CHANGE_ORDER_STATUS_SUCCESS = "CHANGE_ORDER_STATUS_SUCCESS";

constant.FETCH_REVIEWS_SUCCESS = "FETCH_REVIEWS_SUCCESS";
constant.ADD_REVIEW_SUCCESS = "ADD_REVIEW_SUCCESS";

constant.FETCH_ALL_ADMIN_SUCCESS = "FETCH_ALL_ADMIN_SUCCESS";
constant.ADMIN_SIGNUP_SUCCESS = "ADMIN_SIGNUP_SUCCESS";
constant.DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";

export default constant;
